export default __webpack_public_path__ + "static/media/image-4.9983d7ee.jpg";